import {createActions} from 'client/framework';

const normalActions = ['SET_FORM_ERRORS', 'CLEAR_FORM_ERRORS', 'CLEAR_FIELD_ERROR'];

export default createActions(null, normalActions);
